import React, { createContext, useState, useEffect } from 'react';
export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const storedEmail = localStorage.getItem('email');
  const storedCurrentStep = localStorage.getItem('currentStep');
  const storedStatusStep = localStorage.getItem('statusStep');
  const [email, setEmail] = useState(storedEmail || "");
  const [responseMessage, setResponseMessage] = useState("");
  const [ordValue, setOrdValue] = useState(); 
  const [currentUrl, setCurrentUrl] = useState("");
  const [currentStep, setCurrentStep] = useState(storedCurrentStep ? parseInt(storedCurrentStep) : 0);
  const [statusStep, setStatusStep] = useState(storedStatusStep ? parseInt(storedStatusStep) : 0);

  useEffect(() => {
    if (email !== undefined) {
      localStorage.setItem('email', email);
    }
    if (currentStep !== undefined) {
      localStorage.setItem('currentStep', currentStep);
    }
    if (statusStep !== undefined) {
      localStorage.setItem('statusStep', statusStep);
    }
    if (ordValue !== undefined) { // Persist ordValue to localStorage
      localStorage.setItem('ordValue', ordValue);
    }
  }, [email, currentStep, statusStep, ordValue]); // Add ordValue to dependencies

  return (
    <AppContext.Provider
      value={{
        email,
        setEmail,
        responseMessage,
        setResponseMessage,
        currentUrl,
        setCurrentUrl,
        currentStep,
        setCurrentStep,
        statusStep,
        setStatusStep,
        ordValue,
        setOrdValue,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
